import EmptyData from 'components/EmptyData';
import { AgreementSignTypeEnum } from 'modules/Agreement/type';
import { AgreementItemType } from 'types/common';
import classlist from 'utils/classlist';
import AgreementContent from './AgreementContent';
import AgreementLink from './AgreementLink';
import { AgreementProps } from './type';
import './style.scss';

export interface AgreementDataItemType extends Omit<AgreementItemType, 'id'> {
    id?: AgreementProps['id'];
    content?: AgreementProps['content'];
    sign_type?: AgreementSignTypeEnum;
}

interface AgreementListProps {
    agreementsData?: AgreementDataItemType[];
    className?: string;
}

/**
 * @description 只需要传入agreementData数据, 即可渲染对应的协议内容
 * 只有一条协议的时候, 会直接展示协议内容; 否则会用点击弹窗的形式展示协议内容
 */
const AgreementList: React.FC<AgreementListProps> = ({ agreementsData, className }) => {
    if (!agreementsData?.length) {
        return <EmptyData emptyText={__('暂无协议')} />;
    }

    return (
        <div className={classlist('agreement-list-root', className)}>
            {agreementsData.length > 1 ? (
                agreementsData.map(({ title, id, content, link_code }, index) => (
                    // 在这里透传参数给Agreement组件即可，会根据参数决定展示的内容
                    <AgreementLink key={index} linkCode={link_code} id={id} title={title} content={content} />
                ))
            ) : (
                <>
                    <p className="agreement-title fs-5">{agreementsData[0].title}</p>
                    <AgreementContent
                        className="agreement-content"
                        id={agreementsData[0].id}
                        content={agreementsData[0].content}
                    />
                </>
            )}
        </div>
    );
};

export default AgreementList;
